import { localNowForDb } from '@shared/utils/local-time';

/** Audit columns required by STG_TREXA upsert / NOT NULL constraints. */
export interface AuditFields {
  isDeleted: boolean;
  createdBy: number;
  createdDate: string;
  updatedBy: number;
  updatedDate: string;
}

export function buildAuditFields(userId: number, now = localNowForDb()): AuditFields {
  return {
    isDeleted: false,
    createdBy: userId,
    createdDate: now,
    updatedBy: userId,
    updatedDate: now,
  };
}

export function newEntityGuid(): string {
  return crypto.randomUUID();
}

/** HotChocolate UpsertInput requires both `item` and `items`. */
export function upsertInput<T>(item: T, items?: T[]): { item: T; items: T[] } {
  const list = items ?? [item];
  return { item, items: list };
}
